import { useEffect, useState } from "react";

/**
 * Returns `value` once it has been stable for `delayMs`, so fast-changing
 * inputs (search boxes) don't trigger a fetch per keystroke. The returned
 * value lags the input by `delayMs`.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
